import { connect } from 'react-redux';

import {
  optimisticallyDeleteRole,
  setRole,
  toggleDrawer,
} from '../redux/actions';

import { DeleteRoleModal } from './DeleteRoleModal';

const mapStateToProps = (state) => {
  return {
    role: state.rolesPermissions.role,
  };
};

const mapDispatchToProps = {
  optimisticallyDeleteRole,
  toggleDrawer,
  setRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteRoleModal);
